import styled from "styled-components";
import { ContainerDiv } from "../../layout/container/styles";
import { HeaderButton } from "../../components/header/styles";

export const AnimationWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  height: 300px;
`;

export const VectorWrapper = styled.div<{ $paddingTop?: number }>`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  padding-top: ${(props) => (props.$paddingTop ? `${props.$paddingTop}px` : `40px`)};
  padding-bottom: 20px;
`;

export const CalendlyWrapper = styled.div<{ $show: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  background: #f3f3f3;
  right: 0;
  bottom: 0;
  ${(props) => (props.$show ? "display:flex;" : "display:none")};
  z-index: 1000;
  iframe {
    margin-top: 40px;
    width: 100%;
    height: calc(100% - 40px);
  }
`;

export const CalendlyExitButton = styled(HeaderButton)`
  position: absolute;
  top: 14px;
  right: 14px;
  z-index: 1002;
  button {
    background: none;
    outline: none;
    border: none;
    cursor: pointer;
    font-family: suisse;
  }
`;

export const TransferCheckContainer = styled(ContainerDiv)<{ $narrow: boolean }>`
  ${(props) =>
    props.$narrow &&
    `
    h2
    ,p{
    max-width: 260px;
    margin-left:auto;
    margin-right: auto;
    }`}
`;

export const PhoneCallLoadingScreen = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.75);
  right: 0;
  bottom: 0;
  z-index: 1001;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ProgressBarContainer = styled.div`
  margin-top: -20px;
  width: 100%;
  display: flex;
  justify-content: center;
  padding-left: 8px;
`;

export const TransferCheckContent = styled.div`
  display: flex;
  padding-left: 32px;
  max-width: 294px;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
  margin-bottom: 40px;
`;

export const TransferCheckAnimationContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
`;
